import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import _ from 'lodash';
import {
  Link,
  withRouter,
} from 'react-router-dom';
import {
  Button,
  UncontrolledTooltip,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import { showModal } from '../actions';
import { showConfirmationModal } from '../actions/App';
import {
  fetchFiles,
  setFileModalOpen,
  setFileCommentsAnnotateMode,
  setFileEditions,
  updateFilesOnFilesList,
  updateFilesOnSelectedFilesList,
  removeFilesFromFilesList,
  refreshFiles,
  restoreDeletedFile,
  unsetSelectedFile,
  deleteFilePermanent,
} from '../actions/Files';
import { fetchFiles as fetchShareFiles } from '../actions/Shares';

import { isLoggedIn } from '../api/Auth';
import {
  APIgetFile,
  APIgetFileLog,
  APIgetFileInfo,
  APIregisterFileView,
} from '../api/Files';
import { APIgetPageFiles } from '../api/Pages';
import { APIregisterShareFileView } from '../api/Shares';

import FileHeaderActions from '../components/File/Header/Actions';
import FileCollectionsPopover from '../components/File/Header/CollectionsPopover';
import FileView from '../components/File/View';
import GridItemLikes from '../components/GridItemLikes';
import FileRelatedFiles from '../components/File/RelatedFiles';
import FileSidebar from '../components/File/Sidebar/Sidebar';
import FileHeaderShareButton from '../components/File/Header/ShareButton';
import FileToolsRibbon from '../components/File/ToolsRibbon';
import FileDesignPickleIntegrationButton from '../components/File/DesignPickleIntegrationButton';
import ProcessingIcon from '../components/ProcessingIcon';
import LoadingFile from '../components/LoadingFile';

import { sendTrackingEvent } from '../helpers';
import { isArchive, isTrash } from '../helpers/App';
import {
  userCanSeeLikes,
  getCurrentUser,
  userHasAccessToken,
  userCan,
  userHasCap,
} from '../helpers/Auth';
import {
  eventDispatch,
  eventSubscribe,
  eventUnsubscribe,
} from '../helpers/Events';
import {
  getFileExtension,
  isFileProcessing,
  isPeopleFilterActive,
} from '../helpers/Files';
import { addFlashMessage } from '../helpers/FlashMessages';
import { getSetting, getUserSetting } from '../helpers/Settings';

const fileNavigationClick = () => {
  eventDispatch('fileSwitch', {});
};

class File extends PureComponent {
  constructor(props) {
    super(props);

    this.state = this.getInitialState();

    this.updateCurrentFile = this.updateCurrentFile.bind(this);
    this.updateCommentsCount = this.updateCommentsCount.bind(this);
    this.afterCreateVersion = this.afterCreateVersion.bind(this);
    this.afterCreateEdition = this.afterCreateEdition.bind(this);
    this.switchVersion = this.switchVersion.bind(this);
    this.switchEdition = this.switchEdition.bind(this);
    this.loadFileInfo = this.loadFileInfo.bind(this);
    this.loadFileHistory = this.loadFileHistory.bind(this);
    this.updateFileFields = this.updateFileFields.bind(this);
    this.updateFileFace = this.updateFileFace.bind(this);
    this.handleSwitchEmptyFields = this.handleSwitchEmptyFields.bind(this);
    this.handleSwitchEmptyCustomFields = this.handleSwitchEmptyCustomFields.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.isClosable = this.isClosable.bind(this);
    this.setEventListeners = this.setEventListeners.bind(this);
    this.removeEventListeners = this.removeEventListeners.bind(this);
    this.handleFileEdition = this.handleFileEdition.bind(this);
    this.handleSidebarTab = this.handleSidebarTab.bind(this);
    this.hasEmptyTaxonomies = this.hasEmptyTaxonomies.bind(this);
    this.maybeReloadFiles = this.maybeReloadFiles.bind(this);
  }

  getInitialState() {
    return {
      file: null,
      fileIndex: null,
      fileVersion: null,
      fileEdition: null,
      fileParent: null,
      canViewParent: false,
      loading: false,
      infoLoading: 0,
      nextFile: null,
      previousFile: null,
      fileCollections: [],
      fileLog: [],
      fileViews: null,
      showEmptyFields: getUserSetting('show_empty_fields') || false,
      showEmptyCustomFields: getUserSetting('show_empty_custom_fields') || false,
      refreshOnClose: false,
      sidebarTab: 'details',
    };
  }

  componentDidMount() {
    this.isComponentMounted = true;

    document.addEventListener('keydown', this.handleKeyDown);
    eventSubscribe('fileUpdated', this.loadFileHistory);
    eventSubscribe('fileUpdated', this.updateFileFields);
    eventSubscribe('faceUpdated', this.updateFileFace);
    this.setCurrentFile();
    this.checkCommentsUrlParams();
    this.setFileModalStatus(true);

    sendTrackingEvent('single-file-open');
  }

  componentDidUpdate(prevProps) {
    const {
      match,
      history,
      selectedFile,
      files,
      modal,
      fileEditions,
      comments,
    } = this.props;
    const {
      file,
      fileEdition,
      fileIndex,
      nextFile,
      previousFile,
    } = this.state;

    if (match.params.pageId && files !== prevProps.files && file) {
      if (files.length > 0) {
        const index = files.findIndex(f => f.uuid === file.uuid);
        this.setState({ fileIndex: Math.max(index, 0) }, () => this.setFilesIndexes());
      }
      return;
    }

    if (files.length === 0 && prevProps.files.length > 0 && modal !== 'AccessModal') {
      history.push(this.getCloseUrl().pathname);
      return;
    }

    const currentFile = this.getCurrentFile();

    if (
      currentFile &&
      currentFile.uuid !== match.params.fileId &&
      match.params.fileId !== prevProps.match.params.fileId
    ) {
      this.setCurrentFile();
      return;
    }

    if (fileEditions.length < prevProps.fileEditions.length) {
      if (fileEdition && !fileEditions.find(e => e.uuid === fileEdition.shareUuid)) {
        if (fileEdition.can_view_parent) {
          this.switchEdition(null);
        } else {
          window.location = '/';
        }
      }
    }

    if (files.length < prevProps.files.length) {
      if (!(currentFile && !files.find(f => f.uuid === currentFile.uuid))) {
        if (fileIndex > 0) {
          this.setState({ fileIndex: fileIndex - 1 });
        }
      } else if (nextFile) {
        history.push(this.getFileUrl(nextFile));
      } else if (previousFile) {
        history.push(this.getFileUrl(previousFile));
      }
      return;
    } if (files.length > prevProps.files.length) {
      if ((currentFile && files.find(f => f.uuid === currentFile.uuid))) {
        this.setState({ fileIndex: fileIndex + 1 });
      }
    }

    if (match.params.fileId !== prevProps.match.params.fileId) {
      this.setCurrentFile();
      this.loadFileInfo();
      return;
    }

    if (file && selectedFile !== prevProps.selectedFile) {
      if (prevProps.selectedFile && prevProps.selectedFile.uuid === file.uuid) {
        this.setCurrentFile();
      }
    }

    if (fileEdition) {
      const editionFileIndex = files.findIndex(f => (f.uuid === fileEdition.uuid));
      if (files[editionFileIndex] && !_.isEqual(files[editionFileIndex], fileEdition)) {
        this.setState({ fileEdition: files[editionFileIndex] });
      }
    }

    if (comments.length !== prevProps.comments.length) {
      this.loadFileInfo();
    }
  }

  componentWillUnmount() {
    const {
      changeCommentsAnnotateMode,
      handleSetEditions,
    } = this.props;
    document.removeEventListener('keydown', this.handleKeyDown);
    eventUnsubscribe('fileUpdated', this.loadFileHistory);
    eventUnsubscribe('fileUpdated', this.updateFileFields);
    eventUnsubscribe('fileUpdated', this.updateFileUrls);
    eventUnsubscribe('faceUpdated', this.updateFileFace);
    changeCommentsAnnotateMode(false);
    this.isComponentMounted = false;
    this.setFileModalStatus(false);
    handleSetEditions([]);
  }

  isClosable() {
    const {
      modal,
      collectionAddModal,
      collectionEditModal,
      collectionMoveModal,
      collectionMoveModalOpen,
      commentsAnnotateMode,
    } = this.props;

    if (
      modal ||
      collectionAddModal ||
      collectionEditModal ||
      collectionMoveModal ||
      collectionMoveModalOpen ||
      commentsAnnotateMode
    ) {
      return false;
    }

    const pdfTipContainer = document.querySelector('.PdfHighlighter__tip-container');
    if (pdfTipContainer) {
      return false;
    }

    const imageTipContainer = document.querySelector('.image-comment-tip-wrapper');
    if (imageTipContainer) {
      return false;
    }

    return true;
  }

  handleKeyDown(e) {
    if (
      document.getElementsByClassName('editable-field-editing').length > 0 ||
      document.getElementsByClassName('file-transcription-editing').length > 0
    ) {
      return;
    }

    let link = null;
    if (e.key === 'ArrowRight') {
      link = document.getElementById('FileNavNextFile');
    }
    if (e.key === 'ArrowLeft') {
      link = document.getElementById('FileNavPreviousFile');
    }
    if (e.key === 'Escape' && this.isClosable()) {
      link = document.getElementById('FileNavClose');
    }
    if (link) {
      link.click();
    }
  }

  handleFileEdition(fileEdition) {
    this.setState({
      fileEdition,
    });
  }

  getFileUrl(file) {
    const {
      match,
      location,
      shareUuid,
      shareCollectionUuid,
    } = this.props;
    const { pageId } = match.params;

    if (file) {
      if (pageId) {
        const pageRouteId = location.state?.pageRouteId || pageId;
        const pageBasePath = location.pathname.indexOf('/content/') === 0 ? 'content' : 'pages';

        return {
          pathname: `/${pageBasePath}/${pageRouteId}/file/${file.uuid}`,
          state: {
            ...(location.state || {}),
            modal: true,
            pageId,
            pageRouteId,
            pageFile: file,
          },
        };
      }

      let sharePath = `/shares/${shareUuid}`;
      if (shareCollectionUuid) {
        sharePath = `${sharePath}/collections/${shareCollectionUuid}`;
      }

      return {
        pathname: shareUuid ?
          `${sharePath}/files/${file.uuid}` :
          `${isArchive() ? '/archive' : ''}/files/${file.uuid}`,
        state: location.state || { modal: true },
      };
    }

    return null;
  }

  getCloseUrl() {
    const {
      originalLocation,
      location,
      shareUuid,
      shareCollectionUuid,
    } = this.props;

    const getPathname = () => {
      if (isArchive()) {
        return '/archive/files';
      }
      if (isTrash()) {
        return '/trash';
      }
      return '/files';
    };

    const urlParamsOnClose = location.state && location.state.urlParamsOnClose ? location.state.urlParamsOnClose : '';

    if (location.state) {
      if (location.state.backUrl) {
        const [backPathname, backSearch] = String(location.state.backUrl).split('?');
        const backUrlState = (
          location.state.backUrlState
          && typeof location.state.backUrlState === 'object'
          && !Array.isArray(location.state.backUrlState)
        )
          ? location.state.backUrlState
          : null;

        return {
          pathname: backPathname,
          ...(backSearch ? { search: `?${backSearch}` } : {}),
          ...(backUrlState ? { state: backUrlState } : {}),
        };
      }
      if (location.state.fromDashboard) {
        return { pathname: '/' };
      }
      if (location.state.fromFTPQueue) {
        return { pathname: '/admin/ftp-queue' };
      }
      if (location.state.closeUrl) {
        return { pathname: location.state.closeUrl };
      }
    }

    if (shareUuid) {
      let sharePath = `/shares/${shareUuid}`;
      if (shareCollectionUuid) {
        sharePath = `${sharePath}/collections/${shareCollectionUuid}`;
      }
      return { pathname: sharePath };
    }

    if (originalLocation && originalLocation.pathname !== location.pathname) {
      if ((
        originalLocation.pathname === '/results' ||
        originalLocation.pathname === '/files' ||
        originalLocation.pathname.indexOf('/collections') === 0) &&
        urlParamsOnClose
      ) {
        return {
          pathname: originalLocation.pathname,
          search: urlParamsOnClose,
          state: { preventUpdateParams: urlParamsOnClose.length > 0 },
        };
      }
      if (/^\/(pages|content)\//.test(originalLocation.pathname)) {
        return {
          pathname: originalLocation.pathname,
          search: originalLocation.search || '',
        };
      }
      return { pathname: originalLocation.pathname };
    }

    return {
      pathname: getPathname(),
      search: urlParamsOnClose,
      state: {
        preventUpdateParams: location.state && urlParamsOnClose && urlParamsOnClose > 0,
      },
    };
  }

  getCurrentFile() {
    const { files } = this.props;
    const {
      file,
      fileIndex,
    } = this.state;

    let currentFile = file;
    if (!currentFile) {
      currentFile = files[fileIndex];
    }

    return currentFile;
  }

  getFileVersion(versionId) {
    const file = this.getCurrentFile();
    if (!file.versions) {
      return false;
    }

    return file.versions.find(v => (v.id === versionId)) || false;
  }

  getFileVersionObject(file) {
    const { fileVersion } = this.state;

    const version = this.getFileVersion(fileVersion);
    if (!version) {
      return file;
    }

    const newFile = Object.assign({}, file);
    newFile.path = version.path;
    newFile.name = version.name;
    if (version.original_name) {
      newFile.original_name = version.original_name;
    }
    newFile.display_name = version.display_name;
    newFile.description = version.description;
    newFile.urls = version.urls;
    newFile.readable_size = version.readable_size;
    newFile.attributes = version.attributes;
    newFile.extension = getFileExtension(version).toLowerCase();
    newFile.type = version.type;
    newFile.type_group = version.type_group;

    return newFile;
  }

  getNextFileVersion(file) {
    const { fileVersion } = this.state;

    if (!file) {
      return false;
    }

    if (!fileVersion) {
      return file.versions[0];
    }

    const versionIndex = file.versions.findIndex(v => (v.id === fileVersion));
    if (versionIndex >= 0) {
      if (file.versions[versionIndex + 1]) {
        return file.versions[versionIndex + 1];
      }
      return file;
    }

    return false;
  }

  getFileVersionUser(file) {
    const nextFileVersion = this.getNextFileVersion(file);

    return (nextFileVersion && nextFileVersion.user) ? nextFileVersion.user : null;
  }

  getFileVersionDate(file) {
    const nextFileVersion = this.getNextFileVersion(file);

    return nextFileVersion ? nextFileVersion.created_at : null;
  }

  getFileEditionObject(fileEdition) {
    const file = this.getCurrentFile();
    if (!file) return null;

    const newFile = Object.assign({}, fileEdition);
    newFile.versions = file.versions;

    return newFile;
  }

  // eslint-disable-next-line class-methods-use-this
  getPageRouteClosePath(pageId, pathname) {
    if (!pageId) {
      return '/files';
    }

    if (pathname.indexOf('/content/') === 0) {
      return `/content/${pageId}`;
    }

    return `/pages/${pageId}`;
  }

  setFilesIndexes() {
    const { files } = this.props;
    const { fileIndex } = this.state;

    let nextFile = null;
    let previousFile = null;
    if (fileIndex > 0) {
      if (files[fileIndex - 1]) {
        previousFile = files[fileIndex - 1];
      }
    }
    if (fileIndex < files.length) {
      if (files[fileIndex + 1]) {
        nextFile = files[fileIndex + 1];
      }
    }

    this.setState({
      nextFile,
      previousFile,
    });
  }

  setCurrentFile() {
    const {
      history,
      match,
      location,
      files,
      shareUuid,
      filesEnd,
      filesLoading,
      loadShareFiles,
    } = this.props;
    const {
      fileId,
      pageId,
    } = match.params;

    if (fileId) {
      const pageRouteFile = location.state?.pageFile;

      if (pageId && pageRouteFile?.uuid === fileId) {
        this.setState({
          file: pageRouteFile,
          fileIndex: Math.max(files.findIndex(f => f.uuid === fileId), 0),
          fileVersion: null,
          loading: false,
        }, () => {
          this.setFilesIndexes();
          this.switchEdition(null);
          this.registerFileView();
        });
        return;
      }

      if (pageId) {
        this.setState({ loading: true });
        APIgetPageFiles(pageId, [fileId]).then((response) => {
          const pageFiles = response.data?.data || [];
          const foundPageFile = pageFiles.find(f => f.uuid === fileId);

          if (foundPageFile) {
            this.setState({
              file: foundPageFile,
              fileIndex: Math.max(files.findIndex(f => f.uuid === fileId), 0),
              fileVersion: null,
              loading: false,
            }, () => {
              this.setFilesIndexes();
              this.switchEdition(null);
              this.registerFileView();
            });
            return;
          }

          history.push(this.getPageRouteClosePath(pageId, location.pathname));
        }).catch(() => {
          history.push(this.getPageRouteClosePath(pageId, location.pathname));
        });
        return;
      }

      if (files.length > 0 &&
        (!location.state || !location.state.fromSearch) &&
        (!location.state || !location.state.search) &&
        (!location.state || !location.state.fromCollectionSidebar) &&
        (!location.state || !location.state.fromDashboard) &&
        (!location.state || !location.state.fromFTPQueue) &&
        (!location.state || !location.state.backUrl)
      ) {
        const newFileIndex = files.findIndex(f => (f.uuid === fileId));
        if (newFileIndex >= 0) {
          if (!shareUuid && files[newFileIndex].parent_uuid) {
            /* If file is and edition, we should get information about its parent
              (to display the 'View original file' button) */
            if (files[newFileIndex].can_view_parent) {
              APIgetFile(files[newFileIndex].parent_uuid).then((response) => {
                if (response.data) {
                  this.setState({
                    file: response.data,
                    fileIndex: newFileIndex,
                    fileVersion: null,
                    loading: false,
                  }, () => {
                    this.switchEdition(files[newFileIndex]);
                    this.setFilesIndexes();
                    this.registerFileView();
                  });
                }
              });
            } else {
              this.setState({
                file: files[newFileIndex],
                fileIndex: newFileIndex,
                fileVersion: null,
                loading: false,
              }, () => {
                this.switchEdition(files[newFileIndex]);
                this.setFilesIndexes();
                this.registerFileView();
              });
            }
          } else {
            this.setState({
              file: null,
              fileIndex: newFileIndex,
              fileVersion: null,
            }, () => {
              this.setFilesIndexes();
              this.loadMoreFiles();
              this.switchEdition(null);
              this.registerFileView();
            });
          }
        } else if (shareUuid && !filesEnd && !filesLoading) {
          loadShareFiles();
        }
      } else {
        this.setState({ loading: true });
        APIgetFile(fileId).then((response) => {
          if (response.data) {
            if (response.data.parent_uuid) {
              if (response.data.can_view_parent) {
                APIgetFile(response.data.parent_uuid).then((parentResponse) => {
                  if (parentResponse.data) {
                    this.setState({
                      file: parentResponse.data,
                      fileIndex: 0,
                      fileVersion: null,
                      loading: false,
                    });
                    this.switchEdition(response.data);
                    this.registerFileView();
                  }
                });
              } else {
                this.setState({
                  file: response.data,
                  fileIndex: 0,
                  fileVersion: null,
                  loading: false,
                });
                this.switchEdition(response.data);
                this.registerFileView();
              }
            } else {
              this.setState({
                file: response.data,
                fileIndex: 0,
                fileVersion: null,
                loading: false,
              });
              this.switchEdition(null);
              this.registerFileView();
            }
          } else {
            history.push(`${isArchive() ? '/archive' : ''}/files`);
          }
        }).catch(() => {
          history.push(`${isArchive() ? '/archive' : ''}/files`);
        });
      }
    }
  }

  setFileModalStatus(status) {
    const { setModalStatus } = this.props;
    setModalStatus(status);
  }

  /* eslint-disable class-methods-use-this */
  setEventListeners() {
    document.addEventListener('keydown', this.handleKeyDown);
  }

  removeEventListeners() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  showFileNavigation(currentFile) {
    if (currentFile.extension === 'pdf') return false;
    return true;
  }
  /* eslint-enable class-methods-use-this */

  registerFileView() {
    const {
      match,
      shareUuid,
      filesLoading,
    } = this.props;
    const { fileId } = match.params;

    if (shareUuid) {
      if (!filesLoading) {
        APIregisterShareFileView(shareUuid, fileId);
        if (
          (getCurrentUser() && getCurrentUser().uuid) ||
          userHasAccessToken()
        ) {
          this.loadFileInfo();
        }
      }
    } else {
      const profile = getCurrentUser();
      if (profile && profile.uuid) {
        APIregisterFileView(fileId);
      }
      this.loadFileInfo();
    }
  }

  checkCommentsUrlParams() {
    const hash = window.location.hash.replace('#', '');
    const hashParts = hash.split('-');
    if (
      hash === 'comments' ||
      hash === 'subscribe' ||
      hash === 'unsubscribe' ||
      hashParts[0] === 'comment'
    ) {
      this.handleSidebarTab('comments');
    }
  }

  updateCurrentFile(file) {
    const { file: currentFile, fileEdition } = this.state;
    if (this.isComponentMounted && currentFile && file.uuid === currentFile.uuid) {
      this.setState({ file });
    } else if (fileEdition && file.uuid === fileEdition.uuid) {
      this.setState({ fileEdition: file });
    }
  }

  updateFileFields({ detail: newFile }) {
    const { file } = this.state;
    if (file) {
      this.setState(prevState => ({
        file: {
          ...prevState.file,
          attributes: newFile.attributes,
          display_name: newFile.display_name,
          expired: newFile.expired,
          terms: newFile.terms,
          urls: file.watermarked === newFile.watermarked ? prevState.file.urls : newFile.urls,
        },
      }));
    } else {
      const currentFile = this.getCurrentFile();
      if (currentFile.uuid === newFile.uuid) {
        currentFile.expired = newFile.expired;
        currentFile.display_name = newFile.display_name;
        currentFile.attributes = newFile.attributes;
        if (currentFile.watermarked !== newFile.watermarked) {
          currentFile.urls = newFile.urls;
        }
      }
    }
  }

  updateFileFace(event) {
    const { updateFileOnList } = this.props;
    const { file } = this.state;

    const face = event.detail;
    if (file) {
      this.setState(prevState => ({
        file: {
          ...prevState.file,
          faces: prevState.file.faces.map(f => {
            if (f.uuid === face.uuid) {
              return face;
            }
            return f;
          }),
        },
      }));
    } else {
      const currentFile = this.getCurrentFile();
      const newFile = { ...currentFile };
      newFile.faces = newFile.faces.map(f => {
        if (f.uuid === face.uuid) {
          return face;
        }
        return f;
      });
      newFile.time = new Date();
      updateFileOnList(newFile);
    }

    if (isPeopleFilterActive()) {
      this.setState({ refreshOnClose: true });
    }
  }

  loadMoreFiles() {
    const {
      files,
      filesEnd,
      filesLoading,
      loadFiles,
      loadShareFiles,
      shareUuid,
    } = this.props;
    const { fileIndex } = this.state;

    if (files.length > 0 && !filesEnd && !filesLoading) {
      if (files.length < fileIndex + 5) {
        if (shareUuid) {
          loadShareFiles();
        } else {
          loadFiles();
        }
      }
    }
  }

  loadFileHistory() {
    const { match } = this.props;
    const { fileId } = match.params;

    APIgetFileLog(fileId).then((response) => {
      if (response.data) {
        this.setState({ fileLog: response.data });
      } else {
        this.setState({ fileLog: [] });
      }
    });
  }

  loadFileInfo() {
    const {
      file,
      fileEdition,
      fileIndex,
    } = this.state;
    const {
      match,
      files,
      shareUuid,
      updateFileOnList,
    } = this.props;
    const { fileId } = match.params;

    if (!isLoggedIn()) return;

    this.setState((prevState) => ({
      fileCollections: [],
      fileLog: [],
      infoLoading: prevState.infoLoading + 1,
    }));

    APIgetFileInfo(fileId).then((response) => {
      if (response.data) {
        this.setState({
          fileCollections: response.data.collections,
          fileLog: response.data.log,
          fileViews: response.data.views,
        });

        let newFile = fileEdition ? { ...fileEdition } : { ...file };
        newFile = _.isEmpty(newFile) ||
          (!_.isEmpty(newFile) && !newFile.uuid === fileId) ?
          files.find(f => f.uuid === fileId) : newFile;

        if (newFile?.uuid !== fileId) return;

        newFile.editions_count = response.data.editions_count;
        newFile.faces = response.data.faces;
        newFile.comments_count = response.data.comments_count;
        newFile.comments_copied = response.data.comments_copied;
        newFile.extra_fields = response.data.extra_fields;
        if (newFile.versions) {
          newFile.versions = newFile.versions.map(v => {
            const versionCounted = response.data.versions
              .find(versionCount => versionCount.id === v.id);
            if (versionCounted) {
              return {
                ...v,
                comments_count: versionCounted.comments_count,
                comments_copied: versionCounted.comments_copied,
              };
            }
            return v;
          });
        } else {
          newFile.versions = [];
        }
        if (fileEdition) {
          this.setState({
            fileEdition: newFile,
          });
        } else if (file) {
          this.setState({
            file: newFile,
          });
        } else if (fileIndex !== null && !shareUuid) {
          updateFileOnList(newFile);
        }
      }
    }).finally(() => {
      this.setState((prevState) => ({
        infoLoading: prevState.infoLoading - 1,
      }));
    });
  }

  updateCommentsCount(commentsCount, fileVersion) {
    const { file, fileIndex } = this.state;
    const { files, updateFileOnList } = this.props;

    if (file) {
      if (!fileVersion) {
        this.setState((prevState) => ({
          file: {
            ...prevState.file,
            comments_count: commentsCount,
          },
        }));
      } else {
        const newFile = { ...file };

        newFile.versions = newFile.versions.map(v => {
          if (v.id === fileVersion) {
            return {
              ...v,
              comments_count: commentsCount,
            };
          }
          return v;
        });

        this.setState({ file: newFile });
      }
    } else {
      const newFile = files[fileIndex];
      if (!fileVersion) {
        updateFileOnList({ ...newFile, comments_count: commentsCount });
      } else {
        newFile.versions = newFile.versions.map(v => {
          if (v.id === fileVersion) {
            return {
              ...v,
              comments_count: commentsCount,
            };
          }
          return v;
        });
        updateFileOnList(newFile);
      }
    }
  }

  hasEmptyTaxonomies() {
    const { taxonomies } = this.props;

    const taxonomiesSource = this.getCurrentFile().terms;

    const fileTaxonomies = taxonomiesSource ? taxonomiesSource.map(ft => (ft.taxonomy_id)) : [];
    const emptyTaxonomies = taxonomies.filter(t => (!fileTaxonomies.includes(t.id)));

    return emptyTaxonomies.length > 0;
  }

  afterCreateVersion(file) {
    this.setState({ file, fileVersion: null }, () => {
      this.loadFileInfo();
    });
  }

  afterCreateEdition(edition) {
    const { fileEditions, handleSetEditions } = this.props;

    const newEditions = [edition, ...fileEditions];

    this.handleSidebarTab('editions');
    handleSetEditions(newEditions);
  }

  switchVersion(versionId) {
    const { fileVersion } = this.state;

    const version = this.getFileVersion(versionId);
    if (version) {
      if (fileVersion === versionId) {
        this.setState({
          fileVersion: null,
          fileEdition: null,
        });
      } else {
        this.setState({
          fileVersion: versionId,
          fileEdition: null,
        });
      }
    } else {
      this.setState({ fileVersion: null });
    }
  }

  switchEdition(editionFile) {
    if (editionFile) {
      this.setState({
        fileEdition: editionFile,
        fileVersion: null,
      });
    } else {
      this.setState({ fileEdition: null });
    }
  }

  handleSwitchEmptyFields(showEmptyFields) {
    this.setState({ showEmptyFields });
  }

  handleSwitchEmptyCustomFields(showEmptyCustomFields) {
    this.setState({ showEmptyCustomFields });
  }

  handleSidebarTab(sidebarTab) {
    this.setState({ sidebarTab });
  }

  handleRestoreDeletedFile(file) {
    const {
      intl,
      openConfirmationModal,
      restoreFile,
    } = this.props;

    const modalParams = {
      title: intl.formatMessage({ defaultMessage: 'Are you sure?' }),
      text: intl.formatMessage({
        defaultMessage: 'Are you sure you want to restore this file?',
      }),
      processingText: intl.formatMessage({ defaultMessage: 'Restoring' }),
      onConfirm: () => restoreFile(file.uuid),
    };
    openConfirmationModal(modalParams);
  }

  handleDeleteFilePermanent(file) {
    const {
      intl,
      openConfirmationModal,
      deleteFilePermanentAction,
    } = this.props;

    const modalParams = {
      title: intl.formatMessage({ defaultMessage: 'Are you sure?' }),
      text: intl.formatMessage({
        defaultMessage: 'Are you sure you want to permanently delete this file? If you delete this file it will be deleted permanently from your workspace and all Collections it may be a part of - this can not be undone!',
      }),
      processingText: intl.formatMessage({ defaultMessage: 'Deleting' }),
      onConfirm: () => deleteFilePermanentAction(file.uuid),
    };
    openConfirmationModal(modalParams);
  }

  maybeReloadFiles() {
    const { reloadFiles } = this.props;
    const { refreshOnClose } = this.state;

    if (refreshOnClose) {
      reloadFiles();
    }

    fileNavigationClick();
  }

  render() {
    const {
      intl,
      filesLoading,
      shareUuid,
      share,
      match,
      location,
      fixedModal,
      handleDownloadFile,
      handleDownloadPageFile,
      handleDownloadShareFile,
    } = this.props;
    const {
      fileVersion,
      fileEdition,
      nextFile,
      previousFile,
      loading,
      infoLoading,
      fileCollections,
      fileLog,
      fileViews,
      showEmptyFields,
      showEmptyCustomFields,
      sidebarTab,
    } = this.state;

    let currentFile = this.getCurrentFile();
    if (fileVersion) {
      currentFile = this.getFileVersionObject(currentFile);
    }
    if (currentFile && currentFile.versions && currentFile.versions.length > 0) {
      currentFile.version_user = this.getFileVersionUser(this.getCurrentFile());
      currentFile.version_created_at = this.getFileVersionDate(this.getCurrentFile());
    }

    if (fileEdition) {
      currentFile = this.getFileEditionObject(fileEdition);
    }

    if (loading) {
      return (
        <div className={classnames('file-modal file', { 'file-modal-fixed': fixedModal })}>
          <LoadingFile />
        </div>
      );
    }

    if (!currentFile) {
      if (shareUuid && filesLoading) {
        return (
          <div className={classnames('file-modal file', { 'file-modal-fixed': fixedModal })}>
            <LoadingFile />
          </div>
        );
      }
      return (
        <div className={classnames('file-modal file', { 'file-modal-fixed': fixedModal })} />
      );
    }

    const isPageOpenedFile = !!match?.params?.pageId;
    const readOnly = !!currentFile.deleted_at || isPageOpenedFile;
    const shouldHideFileDetails = !!share?.hide_file_details || isPageOpenedFile;
    const pageCollectionAllowDownload = !!location?.state?.pageCollectionAllowDownload;
    const pageCollectionUuid = location?.state?.pageCollectionUuid || null;
    const canDownloadPageFile = !!(
      isPageOpenedFile
      && currentFile?.type !== 'link'
      && (currentFile?.allow_download || pageCollectionAllowDownload)
    );

    const nextFileTo = this.getFileUrl(nextFile);
    const previousFileTo = this.getFileUrl(previousFile);

    return (
      <div className={classnames('file-modal file', { 'file-modal-fixed': fixedModal })}>
        <header className="file-header">
          <div className="file-header-info">
            <div>
              <h5>{currentFile.display_name}</h5>
            </div>
            {(!shareUuid && !isPageOpenedFile) && (
              <div>
                <FileCollectionsPopover
                  file={currentFile}
                  fileCollections={fileCollections}
                  loading={infoLoading > 0}
                />
              </div>
            )}
          </div>
          <ul className="file-navigation">
            <FileDesignPickleIntegrationButton files={[currentFile]} />
            {!isPageOpenedFile && userCanSeeLikes() && (
              <GridItemLikes
                file={currentFile}
                share={share}
                updateCallback={this.updateCurrentFile}
                inModal={true}
                readOnly={readOnly}
              />
            )}
            {!readOnly && (
              <FileHeaderShareButton
                file={currentFile}
                shareUuid={shareUuid}
              />
            )}
            {((!readOnly && ((share && share.allow_download && currentFile.type !== 'link') || (!share && userCan('file.download', currentFile)))) || canDownloadPageFile) && (
              <Button
                color="primary"
                onClick={(e) => {
                  e.preventDefault();
                  if (shareUuid) {
                    handleDownloadShareFile(share, currentFile, fileVersion);
                  } else if (canDownloadPageFile) {
                    handleDownloadPageFile(currentFile, fileVersion, {
                      pageId: match.params.pageId,
                      pageCollectionUuid,
                      pageCollectionAllowDownload,
                    });
                  } else {
                    handleDownloadFile(currentFile, fileVersion);
                  }
                }}
              >
                <i className="far fa-download" />
                <span>{intl.formatMessage({ defaultMessage: 'Download' })}</span>
              </Button>
            )}
            {!readOnly && (
              <FileHeaderActions
                file={currentFile}
                shareUuid={shareUuid}
                share={share}
                inModal={true}
                fileVersion={fileVersion}
              />
            )}
            {(currentFile.deleted_at && userCan('file.delete', currentFile)) && (
              <>
                <Button
                  color="primary"
                  onClick={(e) => {
                    e.preventDefault();
                    this.handleRestoreDeletedFile(currentFile);
                  }}
                >
                  <i className="far fa-trash-undo" />
                  <span>{intl.formatMessage({ defaultMessage: 'Restore' })}</span>
                </Button>
                {userHasCap('delete_files_collections_permanent') && (
                  <Button
                    color="link"
                    onClick={(e) => {
                      e.preventDefault();
                      this.handleDeleteFilePermanent(currentFile.uuid);
                    }}
                  >
                    <i className="fas fa-trash" />
                    <span>{intl.formatMessage({ defaultMessage: 'Delete permanently' })}</span>
                  </Button>
                )}
              </>
            )}
            {(!isPageOpenedFile || previousFileTo || nextFileTo) && (
              <li className="navigation-files-control">
                {previousFileTo && (
                  <>
                    <Link to={previousFileTo} id="FileNavPreviousFile" className="file-nav-previous" onClick={fileNavigationClick}>
                      <i className="far fa-angle-left" />
                    </Link>
                    <UncontrolledTooltip placement="bottom" target="FileNavPreviousFile">
                      {intl.formatMessage({ defaultMessage: 'Previous file' })}
                    </UncontrolledTooltip>
                  </>
                )}
                {!previousFileTo && (
                  <span className="file-nav-previous">
                    <i className="far fa-angle-left" />
                  </span>
                )}
                {nextFileTo && (
                  <>
                    <Link to={nextFileTo} id="FileNavNextFile" className="file-nav-next" onClick={fileNavigationClick}>
                      <i className="far fa-angle-right" />
                    </Link>
                    <UncontrolledTooltip placement="bottom" target="FileNavNextFile">
                      {intl.formatMessage({ defaultMessage: 'Next file' })}
                    </UncontrolledTooltip>
                  </>
                )}
                {!nextFileTo && (
                  <span className="file-nav-next">
                    <i className="far fa-angle-right" />
                  </span>
                )}
              </li>
            )}
            <li className="navigation-close">
              <Link
                to={this.getCloseUrl()}
                onClick={this.maybeReloadFiles}
                id="FileNavClose"
              >
                <i className="far fa-times" />
              </Link>
              <UncontrolledTooltip placement="bottom" target="FileNavClose">
                {intl.formatMessage({ defaultMessage: 'Close' })}
              </UncontrolledTooltip>
            </li>
          </ul>
        </header>
        <div className="file-body">
          <div className={classnames('file-content', { 'file-content-full-width': shouldHideFileDetails })}>
            <div className={`file-inner file-inner-${currentFile.type_group}`}>
              {currentFile.archived && (
                <div className="archived-file">
                  <span>{intl.formatMessage({ defaultMessage: 'Archived file' })}</span>
                </div>
              )}
              <FileToolsRibbon
                file={currentFile}
                fileVersion={fileVersion}
                fileEdition={fileEdition}
                share={share}
                sidebarTab={sidebarTab}
                afterCreateEdition={this.afterCreateEdition}
                afterCreateVersion={this.afterCreateVersion}
                updateCommentsCount={this.updateCommentsCount}
                handleSidebarTab={this.handleSidebarTab}
                switchVersion={this.switchVersion}
                switchEdition={this.switchEdition}
                readOnly={readOnly}
                isPageOpenedFile={isPageOpenedFile}
              />
              {isFileProcessing(currentFile, 'thumbnails') && (
                <div className="file-processing-info">
                  <ProcessingIcon file={currentFile} job="thumbnails" />
                  <span>{intl.formatMessage({ defaultMessage: 'File preview is being generated...' })}</span>
                </div>
              )}
              <div className={`file-wrapper file-wrapper-${currentFile.type_group} file-wrapper-${getFileExtension(currentFile).toLowerCase()}`}>
                <FileView
                  file={currentFile}
                  fileVersion={fileVersion}
                  sidebarTab={sidebarTab}
                  setEventListeners={this.setEventListeners}
                  removeEventListeners={this.removeEventListeners}
                  updateCommentsCount={this.updateCommentsCount}
                  handleSidebarTab={this.handleSidebarTab}
                  readOnly={readOnly}
                />
                {this.showFileNavigation(currentFile) && (
                  <div className="file-sec-navigation">
                    <div className="file-sec-navigation-wrapper">
                      {previousFileTo && (
                        <>
                          <Link to={previousFileTo} id="FileSecNavPreviousFile" className="file-nav-previous" onClick={fileNavigationClick}>
                            <i className="fal fa-angle-left" />
                          </Link>
                          <UncontrolledTooltip placement="bottom" target="FileSecNavPreviousFile">
                            {intl.formatMessage({ defaultMessage: 'Previous file' })}
                          </UncontrolledTooltip>
                        </>
                      )}
                      {!previousFileTo && (
                        <span className="file-nav-previous">
                          <i className="fal fa-angle-left" />
                        </span>
                      )}
                      {nextFileTo && (
                        <>
                          <Link to={nextFileTo} id="FileSecNavNextFile" className="file-nav-next" onClick={fileNavigationClick}>
                            <i className="fal fa-angle-right" />
                          </Link>
                          <UncontrolledTooltip placement="bottom" target="FileSecNavNextFile">
                            {intl.formatMessage({ defaultMessage: 'Next file' })}
                          </UncontrolledTooltip>
                        </>
                      )}
                      {!nextFileTo && (
                        <span className="file-nav-next">
                          <i className="fal fa-angle-right" />
                        </span>
                      )}
                    </div>
                  </div>
                )}
              </div>
              {(!shareUuid && !getSetting('hide_related_files')) && (
                <FileRelatedFiles file={currentFile} />
              )}
            </div>
          </div>
          {!shouldHideFileDetails && (
            <FileSidebar
              handleSidebarTab={this.handleSidebarTab}
              sidebarTab={sidebarTab}
              currentFile={currentFile}
              ts={currentFile.time}
              fileEdition={fileEdition}
              fileVersion={fileVersion}
              shareUuid={shareUuid}
              fileCollections={fileCollections}
              showEmptyFields={showEmptyFields}
              showEmptyCustomFields={showEmptyCustomFields}
              infoLoading={infoLoading > 0}
              fileLog={fileLog}
              fileViews={fileViews}
              hasEmptyTaxonomies={this.hasEmptyTaxonomies}
              handleFileEdition={this.handleFileEdition}
              switchEdition={this.switchEdition}
              switchVersion={this.switchVersion}
              handleSwitchEmptyFields={this.handleSwitchEmptyFields}
              handleSwitchEmptyCustomFields={this.handleSwitchEmptyCustomFields}
              updateCommentsCount={this.updateCommentsCount}
              share={share}
              currentVersionId={fileVersion}
              afterCreateVersion={this.afterCreateVersion}
              afterCreateEdition={this.afterCreateEdition}
              readOnly={readOnly}
            />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  files: state.Files.files,
  filesLoading: state.Files.loading,
  filesEnd: state.Files.end,
  fileEditions: state.Files.fileEditions,
  selectedFile: state.Files.selectedFile,
  taxonomies: state.Metadata.taxonomies,
  commentsLoading: state.Files.commentsLoading,
  commentsAnnotateMode: state.Files.commentsAnnotateMode,
  comments: state.Files.comments,
  collectionAddModal: state.Collections.addModal,
  collectionEditModal: state.Collections.editModal,
  collectionMoveModal: state.Collections.moveModal,
  collectionMoveModalOpen: state.Collections.moveModalOpen,
  modal: state.App.modal,
  share: state.Shares.share,
});

const mapDispatchToProps = (dispatch, props) => ({
  loadFiles: () => {
    dispatch(fetchFiles());
  },
  reloadFiles: () => {
    dispatch(refreshFiles());
  },
  loadShareFiles: () => {
    dispatch(fetchShareFiles());
  },
  setModalStatus: (status) => {
    dispatch(setFileModalOpen(status));
  },
  changeCommentsAnnotateMode: (commentsAnnotateMode) => (
    dispatch(setFileCommentsAnnotateMode(commentsAnnotateMode))
  ),
  handleSetEditions: (editions) => {
    dispatch(setFileEditions(editions));
  },
  updateFileOnList: (file) => {
    dispatch(updateFilesOnFilesList([file]));
    dispatch(updateFilesOnSelectedFilesList([file]));
  },
  removeFileFromList: (file) => {
    dispatch(removeFilesFromFilesList([file]));
  },
  handleDownloadFile: (file, versionId) => {
    dispatch(showModal('DownloadModal', {
      className: 'modal-download modal-download-page-layer',
      files: [file],
      versions: versionId ? [{
        uuid: file.uuid,
        version_id: versionId,
      }] : [],
      backdrop: true,
    }));
  },
  handleDownloadPageFile: (file, versionId, options = {}) => {
    const {
      pageId,
      pageCollectionUuid,
      pageCollectionAllowDownload,
    } = options;

    dispatch(showModal('DownloadModal', {
      className: 'modal-download',
      files: [file],
      versions: versionId ? [{
        uuid: file.uuid,
        version_id: versionId,
      }] : [],
      pageId,
      fileCollectionMap: (pageCollectionAllowDownload && pageCollectionUuid) ? {
        [file.uuid]: [pageCollectionUuid],
      } : {},
      backdrop: true,
    }));
  },
  handleDownloadShareFile: (share, file, versionId) => {
    dispatch(showModal('DownloadModal', {
      className: 'modal-download',
      files: [file],
      versions: versionId ? [{
        uuid: file.uuid,
        version_id: versionId,
      }] : [],
      shareUuid: share.uuid,
      requireName: share.require_name,
      requireEmail: share.require_email,
      backdrop: true,
    }));
  },
  openConfirmationModal: (params) => {
    dispatch(showConfirmationModal(params));
  },
  restoreFile: fileUuid => (
    dispatch(restoreDeletedFile(fileUuid)).then(() => {
      const { intl } = props;
      addFlashMessage({
        type: 'success',
        text: intl.formatMessage({ defaultMessage: 'File has been restored from the trash' }),
      });
      dispatch(unsetSelectedFile());
    })
  ),
  deleteFilePermanentAction: fileUuid => (
    dispatch(deleteFilePermanent(fileUuid)).then(() => {
      const { intl } = props;
      addFlashMessage({
        type: 'success',
        text: intl.formatMessage({ defaultMessage: 'File has been deleted permanently1' }),
      });

      dispatch(unsetSelectedFile());
    })
  ),
});

File.propTypes = {
  intl: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  files: PropTypes.array.isRequired,
  filesLoading: PropTypes.bool.isRequired,
  filesEnd: PropTypes.bool.isRequired,
  fileEditions: PropTypes.array.isRequired,
  handleSetEditions: PropTypes.func.isRequired,
  selectedFile: PropTypes.object,
  taxonomies: PropTypes.array.isRequired,
  comments: PropTypes.array.isRequired,
  commentsAnnotateMode: PropTypes.bool.isRequired,
  originalLocation: PropTypes.object,
  loadFiles: PropTypes.func.isRequired,
  reloadFiles: PropTypes.func.isRequired,
  loadShareFiles: PropTypes.func.isRequired,
  setModalStatus: PropTypes.func.isRequired,
  shareUuid: PropTypes.string,
  share: PropTypes.object,
  shareCollectionUuid: PropTypes.string,
  collectionAddModal: PropTypes.bool.isRequired,
  collectionEditModal: PropTypes.bool.isRequired,
  collectionMoveModal: PropTypes.bool.isRequired,
  collectionMoveModalOpen: PropTypes.bool.isRequired,
  modal: PropTypes.string,
  changeCommentsAnnotateMode: PropTypes.func.isRequired,
  updateFileOnList: PropTypes.func.isRequired,
  handleDownloadFile: PropTypes.func.isRequired,
  handleDownloadPageFile: PropTypes.func.isRequired,
  handleDownloadShareFile: PropTypes.func.isRequired,
  openConfirmationModal: PropTypes.func.isRequired,
  restoreFile: PropTypes.func.isRequired,
  deleteFilePermanentAction: PropTypes.func.isRequired,
  fixedModal: PropTypes.bool,
};

File.defaultProps = {
  selectedFile: null,
  originalLocation: null,
  shareUuid: null,
  share: null,
  shareCollectionUuid: null,
  modal: null,
  fixedModal: false,
};

export default withRouter(injectIntl(connect(mapStateToProps, mapDispatchToProps)(File)));
